import {IElement} from 'routes/private/Editor/types';

export const opacityResolver = ( element: IElement, value?: number ):IElement => {
    element.attributes.opacity = value;
    return element;
}